export default __webpack_public_path__ + "static/media/businessman.6539b86e.svg";